module.exports = __webpack_public_path__ + "static/media/wnyc-logo.22a2459b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wnyc-logo.svg
// module id = 69
// module chunks = 0